import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

export default function NubbiGrid() {
  const [characters, setCharacters] = useState([]);
  const [filteredCharacters, setFilteredCharacters] = useState([]);
  const [modalImage, setModalImage] = useState(null);
  const [universes, setUniverses] = useState([]);
  const [creators, setCreators] = useState([]);

  const [filterBy, setFilterBy] = useState('random');
  const [selectedUniverse, setSelectedUniverse] = useState('all');
  const [selectedCreator, setSelectedCreator] = useState('all');
  const [gridSize, setGridSize] = useState('medium');

  useEffect(() => {
    const fetchData = async () => {
      const { data: allChars, error } = await supabase
        .from('characters')
        .select('*');

      if (!error) {
        const shuffleArray = (array) => {
          return array
            .map((value) => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);
        };

        const shuffled = shuffleArray(allChars);
        setCharacters(shuffled);
        setFilteredCharacters(shuffled);
      }

      const { data: universeList } = await supabase.from('universes').select('*');
      const { data: creatorList } = await supabase.from('creadores').select('*');

      setUniverses(universeList || []);
      setCreators(creatorList || []);
    };

    fetchData();
  }, []);

  useEffect(() => {
    let filtered = [...characters];

    if (selectedUniverse !== 'all') {
      filtered = filtered.filter((char) => char.universo === selectedUniverse);
    }
    if (selectedCreator !== 'all') {
      filtered = filtered.filter((char) => char.creador_url === selectedCreator);
    }

    switch (filterBy) {
      case 'random':
        filtered = filtered.sort(() => 0.5 - Math.random());
        break;
      case 'votos':
        filtered.sort((a, b) => (b.votos || 0) - (a.votos || 0));
        break;
      case 'color':
        filtered.sort((a, b) => (a.color || '').localeCompare(b.color || ''));
        break;
      case 'animal':
        filtered.sort((a, b) => (a.animal || '').localeCompare(b.animal || ''));
        break;
      default:
        break;
    }

    setFilteredCharacters(filtered);
  }, [filterBy, selectedUniverse, selectedCreator, characters]);

  const getGridSize = () => {
    switch (gridSize) {
      case 'small': return '80px';
      case 'large': return '160px';
      case 'xl': return '220px';
      default: return '120px'; // medium
    }
  };

  const dropdownStyle = {
    padding: '10px 14px',
    fontSize: '1rem',
    fontWeight: 'bold',
    borderRadius: '12px',
    border: '2px solid #FFD700',
    backgroundColor: '#fff8dc',
    color: '#444',
    boxShadow: '2px 2px 5px rgba(0,0,0,0.1)',
    cursor: 'pointer',
  };

  return (
    <div style={{ padding: '1rem' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '1rem' }}>🔮 Explore All Nubbis</h2>

      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '1.5rem' }}>
        <select style={dropdownStyle} value={filterBy} onChange={(e) => setFilterBy(e.target.value)}>
          <option value="random">🎲 Random</option>
          <option value="color">🎨 Color</option>
          <option value="animal">🐾 Animal</option>
          <option value="votos">⭐ Ranking</option>
        </select>

        <select style={dropdownStyle} value={selectedUniverse} onChange={(e) => setSelectedUniverse(e.target.value)}>
          <option value="all">🌎 All Universes</option>
          {universes.map((u) => (
            <option key={u.codigo} value={u.codigo}>{u.codigo}</option>
          ))}
        </select>

        <select style={dropdownStyle} value={selectedCreator} onChange={(e) => setSelectedCreator(e.target.value)}>
          <option value="all">👤 All Creators</option>
          {creators.map((c) => (
            <option key={c.url} value={c.url}>{c.nombre_completo}</option>
          ))}
        </select>

        <select style={dropdownStyle} value={gridSize} onChange={(e) => setGridSize(e.target.value)}>
          <option value="small">🔲 Small</option>
          <option value="medium">🟦 Medium</option>
          <option value="large">🟥 Large</option>
          <option value="xl">🟪 XL</option>
        </select>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
          gap: '12px',
        }}
      >
        {filteredCharacters.map((char, idx) => (
          <img
            key={idx}
            src={char.image}
            alt="nubbi"
            onClick={() => setModalImage(char.image)}
            style={{
              width: '100%',
              height: getGridSize(),
              objectFit: 'cover',
              borderRadius: '12px',
              cursor: 'pointer',
              boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            }}
          />
        ))}
      </div>

      {modalImage && (
        <div
          onClick={() => setModalImage(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            cursor: 'zoom-out',
          }}
        >
          <img
            src={modalImage}
            alt="zoomed nubbi"
            style={{ maxHeight: '90%', maxWidth: '90%', borderRadius: '16px' }}
          />
        </div>
      )}
    </div>
  );
}
